import { FormattedMessage } from 'react-intl'
import { ListingDetailsListing } from '../../../../../types/listings'
import { ListingActionBar } from '../../../../ListingDetails/ListingActionBar'

import styles from './PhotoPanelHeader.module.scss'

export interface PhotoPanelHeaderProps {
  index: number
  showTourButton?: boolean
  listing: ListingDetailsListing
}

export const PhotoPanelHeader = ({
  index,
  listing,
  showTourButton = false,
}: PhotoPanelHeaderProps) => {
  return (
    <ListingActionBar
      listing={listing}
      showTourButton={showTourButton}
      headingComponent={
        <span className={styles.imageIndex} data-qa='image-index'>
          <FormattedMessage
            id='HomeSearch.listingDetails.imageIndex'
            defaultMessage='{index} of {total}'
            values={{
              index,
              total: listing.thumbnailImageFileNames.length,
            }}
          />
        </span>
      }
    />
  )
}
